import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Title from './title';
import CustomMenu from './menu';

const MobileHeader = ({
  practiceOptions,
  patientsOptions,
  profileOptions,
  formsOptions,
  adminPanelOptions,
  disableNavigation,
}) => {
  const [swichedMenu, swichMenu] = useState(false);

  return (
    <header className="header-mobile">
      <Title
        showMenu={() => {
          swichMenu(true);
        }}
      />
      <CustomMenu
        formsOptions={formsOptions}
        practiceOptions={practiceOptions}
        patientsOptions={patientsOptions}
        profileOptions={profileOptions}
        adminPanelOptions={adminPanelOptions}
        swiched={swichedMenu}
        closeMenu={() => swichMenu(false)}
        limitedMenu={disableNavigation}
      />
    </header>
  );
};

MobileHeader.propTypes = {
  formsOptions: PropTypes.arrayOf(PropTypes.shape()),
  practiceOptions: PropTypes.arrayOf(PropTypes.shape()),
  patientsOptions: PropTypes.arrayOf(PropTypes.shape()),
  profileOptions: PropTypes.arrayOf(PropTypes.shape()),
  adminPanelOptions: PropTypes.arrayOf(PropTypes.shape()),
  disableNavigation: PropTypes.bool,
};

export default MobileHeader;
